if (typeof boostPFSThemeConfig !== 'undefined') {
	// Override Settings
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSConfig.custom.products_per_page,
            capitalizeFilterOptionValues: false,
      /* Optional */
      loadProductFirst: false,
      refineByStyle: 'style2',
      // filterTreeMobileStyle: 'style3', // 'style1', style2', 'style2-fullwidth','style3', 'style3-fullwidth'
    },
  };
}

var isFirstLoad = boostPFSFilterConfig.general.loadProductFirst;
var numberQuickViewModalLoaded = 0;
(function() {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);

  /************************** BUILD PRODUCT LIST **************************/

  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function(data, index) {
    if (!data) data = this.data;
    if (!index) index = this.index;
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;

    itemHtml = itemHtml.replace(/{{grid_item_width}}/g, boostPFSConfig.custom.grid_item_width);
    itemHtml = itemHtml.replace(/{{products_per_row}}/g, boostPFSConfig.custom.products_per_row);

    // Add Thumbnail
    var aspectRatio = images.length > 0 ? images[0]['width'] / images[0]['height'] : '';
    var paddingBottom = images.length > 0 ? 100 / aspectRatio : '100';
    var thumb = images.length > 0 ? images[0] : boostPFSConfig.general.no_image_url;
    var productGridImageFillClass = '';
    if(boostPFSConfig.custom.hasOwnProperty('product_grid_image_fill') && boostPFSConfig.custom.product_grid_image_fill){
      productGridImageFillClass = 'grid__image-contain';
    }
    var itemImagesHtml = '';
    if (boostPFSConfig.custom.product_grid_image_size == 'natural') {
      itemImagesHtml += '<div class="image-wrap" style="height: 0; padding-bottom: ' + paddingBottom + '%;">';
      itemImagesHtml += '<img ' +
                  'class="grid-product__image lazyload" ' +
                  'data-src="' + Utils.getFeaturedImage(images, '350x') + '" ' +
                  'data-widths="[180, 360, 360, 360, 360, 360, 360, 360, 360, 360]" ' +
                  'data-aspectratio="' + aspectRatio + '" ' +
                  'data-sizes="auto" ' +
                  'alt="{{itemTitle}}">';
      itemImagesHtml += '<noscript>' +
                '<img class="grid-product__image lazyloaded" ' +
                'src="' + Utils.getFeaturedImage(images, '400x') + '" ' +
                'alt="{{itemTitle}">' +
              '</noscript>';
      itemImagesHtml += '</div>';
      
    } else {
      itemImagesHtml += '<div class="grid__image-ratio grid__image-ratio--' + boostPFSConfig.custom.product_grid_image_size + '" >';
      itemImagesHtml += '<img ' +
        'class="lazyload ' + productGridImageFillClass + '" ' +
        'data-src="' + Utils.getFeaturedImage(images, '350x') + '" ' +
        'data-widths="[360, 360, 360, 360, 360]" ' +
        'data-aspectratio="' + aspectRatio + '" ' +
        'data-sizes="auto" ' +
        'alt="{{itemTitle}}">';
      itemImagesHtml += '</div>';
    }
    
  
    if (!soldOut) {
      if (boostPFSConfig.custom.product_hover_image && images.length > 1) {
        itemImagesHtml += '<div class="grid-product__secondary-image small--hide">';
        itemImagesHtml += '<img class="lazyload"' +
          'data-src="' + Utils.optimizeImage(images[1].src, '350x') + '"' +
          'data-widths="[360, 360, 360, 360, 360]"' +
          'data-aspectratio="' + aspectRatio + '"' +
          'data-sizes="auto"' +
          'alt="{{itemTitle}}">';
        itemImagesHtml += '</div>';
      }
    }
    // var sliderfor = ["Semi-Permanent Individual"]

    if(1)
    {
      itemImagesHtml = "<div class='slider-item'>";
      itemImagesHtml += "<div class='slick-slider slick-slider-x'>";
      let images = [];
      images = data.images;

    
      
      
      let x = 1;
      var semi_products = ["Semi-Permanent Individual","Semi-Permanent Pack","Semi-Permanent","Semi-Permanent Stencil Kit","Custom Semi-Permanent","custom-semi-permanent-tattoos"];
      if(semi_products.includes(data.product_type))
      {
        if (semi_permanent_image_1 != null) {
          let nextKey = Object.keys(images).length + 1;  // Get the next available key
          images[nextKey] = semi_permanent_image_1;  // Add the new image
      }
      
      if (semi_permanent_image_2 != null) {
          let nextKey = Object.keys(images).length + 1;  // Get the next available key
          images[nextKey] = semi_permanent_image_2;  // Add the new image
      }
      
      if (semi_permanent_image_3 != null) {
          let nextKey = Object.keys(images).length + 1;  // Get the next available key
          images[nextKey] = semi_permanent_image_3;  // Add the new image
      }
      }
     for (const img in images) {
      if (Object.hasOwnProperty.call(images, img)) {
        const e = images[img];
        
        const modifiedImageUrl = e.includes('x.') || e.includes('_350x.') ? e : e.replace(/(\.[^/.]+)$/, '_350x$1'); // Add _350x before the extension only if it doesn't already contain _x or _350x.
        data.collections.forEach(function(item, i) {
          if (item.handle == "semi-permanent-individual" && x++ == 3) {
        itemImagesHtml += '<a href="{{itemUrl}}"><img lazyload class="lazyload"' +
        'src="https://cdn.shopify.com/s/files/1/1176/9992/files/semi-permanent_tattoos_2.jpg"' +
        'alt="{{itemTitle}}"></a>';
          }
        });
        itemImagesHtml += '<a href="{{itemUrl}}"><img lazyload class="lazyload"' +
        'src="' + modifiedImageUrl + '"' +
        'alt="{{itemTitle}}"></a>'; 
      }
     }
      if (data.tags.includes("Half Sleeve")) {
        itemImagesHtml += '<a href="{{itemUrl}}"><img lazyload class="lazyload"' +
        'src="https://cdn.shopify.com/s/files/1/1176/9992/files/FINAL-Half-Sleeve-Thumbnail.jpg"' +
        'alt="{{itemTitle}}"></a>';
      }
     data.collections.forEach(function(item,i){
      if((item.handle == "semi-permanent-individual") && Object.keys(data.images).length<=1)
      {
        itemImagesHtml += '<a href="{{itemUrl}}"><img lazyload class="lazyload"' +
        'src="https://cdn.shopify.com/s/files/1/1176/9992/files/semi-permanent_tattoos_2.jpg"' +
        'alt="{{itemTitle}}"></a>';
      }
    })
     itemImagesHtml += '</div>'
     itemImagesHtml += '</div>'
    }
    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    // Add Price
    var itemPriceHtml = '';
    if (onSale) {
      itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
      itemPriceHtml += '<span class="grid-product__price--original">' + Utils.formatMoney(data.compare_at_price_min) + '</span>';
      itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.sale_price + '</span>';
    }
    if (priceVaries) {
      itemPriceHtml += boostPFSConfig.label.from_text_html.replace(/{{ price }}/g, Utils.formatMoney(data.price_min));
    } else {
      itemPriceHtml += Utils.formatMoney(data.price_min);
    }
    if (onSale && boostPFSConfig.custom.product_save_amount) {
      var savePrice = '';
      if (boostPFSConfig.custom.product_save_type == 'dollar') {
        savePrice = Utils.formatMoney(data.compare_at_price_min - data.price_min);
      } else {
        savePrice = Math.round((data.compare_at_price_min - data.price_min) * 100 / data.compare_at_price_min);
        savePrice += '%';
      }
      var savePriceText = boostPFSConfig.label.save_html.replace(/{{ saved_amount }}/g, savePrice);;
      itemPriceHtml += '<span class="grid-product__price--savings">' + savePriceText + '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add soldOut class
    var itemSoldOutClass = soldOut ? 'grid-product__link--disabled' : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

    // Add label
    var customLabel = '';
    data.tags.forEach(function(tag) {
      if (tag.startsWith('_label_')) {
        if (!customLabel) {
          customLabel = tag.replace('_label_', '');
        }
      }
    });
    var itemLabelHtml = '';
    if (customLabel) {
      itemLabelHtml = '<div class="grid-product__tag grid-product__tag--custom">' + customLabel + '</div>';
    } else {
      // soldOut Label
      if (soldOut) {
        itemLabelHtml = '<div class="grid-product__tag grid-product__tag--sold-out">' + boostPFSConfig.label.sold_out + '</div>';
      } else if (onSale) {
        itemLabelHtml = '<div class="grid-product__tag grid-product__tag--sale">' + boostPFSConfig.label.sale + '</div>';
      }
    }
    itemHtml = itemHtml.replace(/{{itemLabel}}/g, itemLabelHtml);

    // Add Vendor
    var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? '<div class="grid-product__vendor">' + data.vendor + '</div>' : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Quick shop
    var quickviewExcludeFor = ["Semi-Permanent Individual","Custom Tattoo","Semi-Permanent Pack","Semi-Permanent","Semi-Permanent Stencil Kit","Custom Semi-Permanent"]
    var itemQuickShopClass = '';
    var itemQuickShopButtonHtml = '';
    if (boostPFSConfig.custom.quick_shop_enable && !soldOut) {
      itemQuickShopClass = 'grid-product__has-quick-shop';
      itemQuickShopButtonHtml = ' <div class="quick-view"><a href="javascript:void(0)" data-id="'+data.handle+'" class="btn btn--full btn--secondary js-modal-open-quick-modal-'+data.id+'">Quick view</a></div>';
        if(quickviewExcludeFor.includes(data.product_type))
        {
          itemQuickShopButtonHtml = "";
        }
        if(data.tags.includes("Tattoo Sets"))
        {
          itemQuickShopButtonHtml = "";
        }
        data.collections.forEach(function(item,i){
          if(item.handle == "full-sleeves" || item.handle == "half-sleeves-and-premium-sizes")
          {
            itemQuickShopButtonHtml = "";
          }
        })
        if(data.tags.includes("no-quick-view"))
        {
          itemQuickShopButtonHtml = "";
        }
    }
    itemHtml = itemHtml.replace(/{{itemQuickShopClass}}/g, itemQuickShopClass);
    itemHtml = itemHtml.replace(/{{itemQuickShopButton}}/g, itemQuickShopButtonHtml);

    // Add Reviews
    if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
      var reviewHtml = '';
      if(boostPFSConfig.custom.enable_product_reviews) {
        reviewHtml = '<span class="shopify-product-reviews-badge" data-id="'+ data.id +'"></span>';
      }
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, reviewHtml);
    }

    // Color swatch
    var swatchHtml = buildSwatch(data, this);
    itemHtml = itemHtml.replace(/{{itemSwatch}}/g, swatchHtml.itemSwatch);
    itemHtml = itemHtml.replace(/{{itemSwatchHoverImages}}/g, swatchHtml.itemSwatchHoverImages);

    var itemQuickShopModal = '';

    if (!Utils.isMobile() && boostPFSConfig.custom.quick_shop_enable) {
      itemQuickShopModal = '<div id="QuickShopModal-{{itemId}}" class="modal modal--square modal--quick-shop" data-product-id="{{itemId}}">' +
        '<div class="modal__inner">' +
          '<div class="modal__centered">' +
            '<div class="modal__centered-content">' +
              '<div id="QuickShopHolder-{{itemHandle}}"></div>' +
            '</div>' +

            '<button type="button" class="modal__close js-modal-close text-link">' +
              '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"/></svg>' +
              '<span class="icon__fallback-text">Close Modal</span>' +
            '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickShopModal}}/g, itemQuickShopModal);
    let product_types_for_form = ["Tattoo Sets","Semi-Permanent Individual","Semi-Permanent","Semi-Permanent Pack","Semi-Permanent Stencil Kit"];
    let product_types_for_quickview_exclude = ["Custom Semi-Permanent","Custom Tattoo"];
    let product_first_variant = data.variants[0].id;
    let quick_button = "";
    if(product_types_for_form.includes(data.product_type))
    {
      quick_button = ' <form method="post" class="quick-cart" action="/cart/add">'+
      '<input name="id" value="'+product_first_variant+'" type="hidden" />'+
      '<textarea hidden name="product_type">'+data.product_type+'</textarea>'+
      '<button type="submit" class=""><svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 512 450.01"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M512,79c-3.67,12.21-7.48,24.38-11,36.64Q476.58,200.8,452.26,286c-3.05,10.66-7.63,14.06-18.73,14.06H169.09C157,300,150.1,305.47,150,315S157,330,168.92,330q131.48,0,263,0c1.66,0,3.33,0,5,0,8.63.35,15,6.66,15.1,14.85.08,8.38-6.43,14.9-15.34,15.08-7.49.16-15,0-22.56.33C426.4,363,436.61,369,443.8,379.38s9.38,21.81,7.29,34.24c-3.45,20.57-24,37.23-45.13,36.36-24-1-42-18.6-43.82-42.89-1.67-21.77,14.5-41.73,39.13-46.75h-198c4.6,2,10.47,3.59,15.27,6.8a50.83,50.83,0,0,1,13.24,12.58,43.84,43.84,0,0,1,7,16.33,50.47,50.47,0,0,1,.06,18.3C235.09,435.1,214.52,451,193.69,450c-23.71-1.21-41.43-18.07-43.39-42.15-1.55-19,9.78-41.21,37.64-48.42-9.62,0-19.32.81-28.84-.17-19-1.94-34.73-17-38.1-35.11-3.73-20.05,5.12-39,22.67-48.56,1-.55,2-1.14,3.42-1.95L93,30H42.65c-7.5,0-15-.39-22.49.1C10.85,30.73,4,27.67,0,19V11C3.15,5,7.21.09,14.66.08c30-.08,60-.14,90,0,7.61,0,12.77,4.37,14.94,11.72,1,3.51,1.63,7.13,2.43,10.71C124.82,35,127.6,47.41,130.42,60h6.44q177.5,0,355-.14C501.12,59.87,508,62.36,512,71ZM177,269.86H425.73q25.63-89.7,51.33-179.61h-340C150.4,150.18,163.67,209.89,177,269.86Zm18.09,120.22A15,15,0,1,0,210,405.13,15.09,15.09,0,0,0,195.09,390.08ZM406.85,420A15,15,0,1,0,392,404.89,15.09,15.09,0,0,0,406.85,420Z"/><path d="M357.81,185.61c0,2.51-1.35,3.86-3.86,3.86H313.21v40.74c0,2.51-1.35,3.86-3.86,3.86H291.2c-2.51,0-3.86-1.35-3.86-3.86V189.47H246.6c-2.51,0-3.86-1.35-3.86-3.86V167.46c0-2.51,1.35-3.86,3.86-3.86h40.74V122.86c0-2.51,1.35-3.86,3.86-3.86h18.15c2.51,0,3.86,1.35,3.86,3.86V163.6H354c2.51,0,3.86,1.35,3.86,3.86Z"/></g></g></svg></button></form>';
    }
    
    else if(product_types_for_quickview_exclude.includes(data.product_type))
    {
      quick_button=""
    }
    
    else{
      quick_button = ' <a href="javascript:void(0)" data-id="'+data.handle+'" class="quick-btn js-modal-open-quick-modal-'+data.id+'"><svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 512 450.01"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M512,79c-3.67,12.21-7.48,24.38-11,36.64Q476.58,200.8,452.26,286c-3.05,10.66-7.63,14.06-18.73,14.06H169.09C157,300,150.1,305.47,150,315S157,330,168.92,330q131.48,0,263,0c1.66,0,3.33,0,5,0,8.63.35,15,6.66,15.1,14.85.08,8.38-6.43,14.9-15.34,15.08-7.49.16-15,0-22.56.33C426.4,363,436.61,369,443.8,379.38s9.38,21.81,7.29,34.24c-3.45,20.57-24,37.23-45.13,36.36-24-1-42-18.6-43.82-42.89-1.67-21.77,14.5-41.73,39.13-46.75h-198c4.6,2,10.47,3.59,15.27,6.8a50.83,50.83,0,0,1,13.24,12.58,43.84,43.84,0,0,1,7,16.33,50.47,50.47,0,0,1,.06,18.3C235.09,435.1,214.52,451,193.69,450c-23.71-1.21-41.43-18.07-43.39-42.15-1.55-19,9.78-41.21,37.64-48.42-9.62,0-19.32.81-28.84-.17-19-1.94-34.73-17-38.1-35.11-3.73-20.05,5.12-39,22.67-48.56,1-.55,2-1.14,3.42-1.95L93,30H42.65c-7.5,0-15-.39-22.49.1C10.85,30.73,4,27.67,0,19V11C3.15,5,7.21.09,14.66.08c30-.08,60-.14,90,0,7.61,0,12.77,4.37,14.94,11.72,1,3.51,1.63,7.13,2.43,10.71C124.82,35,127.6,47.41,130.42,60h6.44q177.5,0,355-.14C501.12,59.87,508,62.36,512,71ZM177,269.86H425.73q25.63-89.7,51.33-179.61h-340C150.4,150.18,163.67,209.89,177,269.86Zm18.09,120.22A15,15,0,1,0,210,405.13,15.09,15.09,0,0,0,195.09,390.08ZM406.85,420A15,15,0,1,0,392,404.89,15.09,15.09,0,0,0,406.85,420Z"/><path d="M357.81,185.61c0,2.51-1.35,3.86-3.86,3.86H313.21v40.74c0,2.51-1.35,3.86-3.86,3.86H291.2c-2.51,0-3.86-1.35-3.86-3.86V189.47H246.6c-2.51,0-3.86-1.35-3.86-3.86V167.46c0-2.51,1.35-3.86,3.86-3.86h40.74V122.86c0-2.51,1.35-3.86,3.86-3.86h18.15c2.51,0,3.86,1.35,3.86,3.86V163.6H354c2.51,0,3.86,1.35,3.86,3.86Z"/></g></g></svg></a>'
    }
    if(data.tags.includes("Tattoo Sets"))
        {
          quick_button = ' <form method="post" class="quick-cart" action="/cart/add">'+
          '<input name="id" value="'+product_first_variant+'" type="hidden" />'+
          '<textarea hidden name="product_type">'+data.product_type+'</textarea>'+
          '<button type="submit" class=""><svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 512 450.01"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M512,79c-3.67,12.21-7.48,24.38-11,36.64Q476.58,200.8,452.26,286c-3.05,10.66-7.63,14.06-18.73,14.06H169.09C157,300,150.1,305.47,150,315S157,330,168.92,330q131.48,0,263,0c1.66,0,3.33,0,5,0,8.63.35,15,6.66,15.1,14.85.08,8.38-6.43,14.9-15.34,15.08-7.49.16-15,0-22.56.33C426.4,363,436.61,369,443.8,379.38s9.38,21.81,7.29,34.24c-3.45,20.57-24,37.23-45.13,36.36-24-1-42-18.6-43.82-42.89-1.67-21.77,14.5-41.73,39.13-46.75h-198c4.6,2,10.47,3.59,15.27,6.8a50.83,50.83,0,0,1,13.24,12.58,43.84,43.84,0,0,1,7,16.33,50.47,50.47,0,0,1,.06,18.3C235.09,435.1,214.52,451,193.69,450c-23.71-1.21-41.43-18.07-43.39-42.15-1.55-19,9.78-41.21,37.64-48.42-9.62,0-19.32.81-28.84-.17-19-1.94-34.73-17-38.1-35.11-3.73-20.05,5.12-39,22.67-48.56,1-.55,2-1.14,3.42-1.95L93,30H42.65c-7.5,0-15-.39-22.49.1C10.85,30.73,4,27.67,0,19V11C3.15,5,7.21.09,14.66.08c30-.08,60-.14,90,0,7.61,0,12.77,4.37,14.94,11.72,1,3.51,1.63,7.13,2.43,10.71C124.82,35,127.6,47.41,130.42,60h6.44q177.5,0,355-.14C501.12,59.87,508,62.36,512,71ZM177,269.86H425.73q25.63-89.7,51.33-179.61h-340C150.4,150.18,163.67,209.89,177,269.86Zm18.09,120.22A15,15,0,1,0,210,405.13,15.09,15.09,0,0,0,195.09,390.08ZM406.85,420A15,15,0,1,0,392,404.89,15.09,15.09,0,0,0,406.85,420Z"/><path d="M357.81,185.61c0,2.51-1.35,3.86-3.86,3.86H313.21v40.74c0,2.51-1.35,3.86-3.86,3.86H291.2c-2.51,0-3.86-1.35-3.86-3.86V189.47H246.6c-2.51,0-3.86-1.35-3.86-3.86V167.46c0-2.51,1.35-3.86,3.86-3.86h40.74V122.86c0-2.51,1.35-3.86,3.86-3.86h18.15c2.51,0,3.86,1.35,3.86,3.86V163.6H354c2.51,0,3.86,1.35,3.86,3.86Z"/></g></g></svg></button></form>';
        }
      data.collections.forEach(function(item,i){
        if(item.handle == "full-sleeves" || item.handle == "half-sleeves-and-premium-sizes")
        {
          quick_button = ' <form method="post" class="quick-cart" action="/cart/add">'+
          '<input name="id" value="'+product_first_variant+'" type="hidden" />'+
          '<textarea hidden name="product_type">'+data.product_type+'</textarea>'+
          '<button type="submit" class=""><svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 512 450.01"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M512,79c-3.67,12.21-7.48,24.38-11,36.64Q476.58,200.8,452.26,286c-3.05,10.66-7.63,14.06-18.73,14.06H169.09C157,300,150.1,305.47,150,315S157,330,168.92,330q131.48,0,263,0c1.66,0,3.33,0,5,0,8.63.35,15,6.66,15.1,14.85.08,8.38-6.43,14.9-15.34,15.08-7.49.16-15,0-22.56.33C426.4,363,436.61,369,443.8,379.38s9.38,21.81,7.29,34.24c-3.45,20.57-24,37.23-45.13,36.36-24-1-42-18.6-43.82-42.89-1.67-21.77,14.5-41.73,39.13-46.75h-198c4.6,2,10.47,3.59,15.27,6.8a50.83,50.83,0,0,1,13.24,12.58,43.84,43.84,0,0,1,7,16.33,50.47,50.47,0,0,1,.06,18.3C235.09,435.1,214.52,451,193.69,450c-23.71-1.21-41.43-18.07-43.39-42.15-1.55-19,9.78-41.21,37.64-48.42-9.62,0-19.32.81-28.84-.17-19-1.94-34.73-17-38.1-35.11-3.73-20.05,5.12-39,22.67-48.56,1-.55,2-1.14,3.42-1.95L93,30H42.65c-7.5,0-15-.39-22.49.1C10.85,30.73,4,27.67,0,19V11C3.15,5,7.21.09,14.66.08c30-.08,60-.14,90,0,7.61,0,12.77,4.37,14.94,11.72,1,3.51,1.63,7.13,2.43,10.71C124.82,35,127.6,47.41,130.42,60h6.44q177.5,0,355-.14C501.12,59.87,508,62.36,512,71ZM177,269.86H425.73q25.63-89.7,51.33-179.61h-340C150.4,150.18,163.67,209.89,177,269.86Zm18.09,120.22A15,15,0,1,0,210,405.13,15.09,15.09,0,0,0,195.09,390.08ZM406.85,420A15,15,0,1,0,392,404.89,15.09,15.09,0,0,0,406.85,420Z"/><path d="M357.81,185.61c0,2.51-1.35,3.86-3.86,3.86H313.21v40.74c0,2.51-1.35,3.86-3.86,3.86H291.2c-2.51,0-3.86-1.35-3.86-3.86V189.47H246.6c-2.51,0-3.86-1.35-3.86-3.86V167.46c0-2.51,1.35-3.86,3.86-3.86h40.74V122.86c0-2.51,1.35-3.86,3.86-3.86h18.15c2.51,0,3.86,1.35,3.86,3.86V163.6H354c2.51,0,3.86,1.35,3.86,3.86Z"/></g></g></svg></button></form>';
        }
      })
      if(data.tags.includes("no-quick-view"))
      {
        quick_button = ' <form method="post" class="quick-cart" action="/cart/add">'+
        '<input name="id" value="'+product_first_variant+'" type="hidden" />'+
        '<textarea hidden name="product_type">'+data.product_type+'</textarea>'+
        '<button type="submit" class=""><svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 512 450.01"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M512,79c-3.67,12.21-7.48,24.38-11,36.64Q476.58,200.8,452.26,286c-3.05,10.66-7.63,14.06-18.73,14.06H169.09C157,300,150.1,305.47,150,315S157,330,168.92,330q131.48,0,263,0c1.66,0,3.33,0,5,0,8.63.35,15,6.66,15.1,14.85.08,8.38-6.43,14.9-15.34,15.08-7.49.16-15,0-22.56.33C426.4,363,436.61,369,443.8,379.38s9.38,21.81,7.29,34.24c-3.45,20.57-24,37.23-45.13,36.36-24-1-42-18.6-43.82-42.89-1.67-21.77,14.5-41.73,39.13-46.75h-198c4.6,2,10.47,3.59,15.27,6.8a50.83,50.83,0,0,1,13.24,12.58,43.84,43.84,0,0,1,7,16.33,50.47,50.47,0,0,1,.06,18.3C235.09,435.1,214.52,451,193.69,450c-23.71-1.21-41.43-18.07-43.39-42.15-1.55-19,9.78-41.21,37.64-48.42-9.62,0-19.32.81-28.84-.17-19-1.94-34.73-17-38.1-35.11-3.73-20.05,5.12-39,22.67-48.56,1-.55,2-1.14,3.42-1.95L93,30H42.65c-7.5,0-15-.39-22.49.1C10.85,30.73,4,27.67,0,19V11C3.15,5,7.21.09,14.66.08c30-.08,60-.14,90,0,7.61,0,12.77,4.37,14.94,11.72,1,3.51,1.63,7.13,2.43,10.71C124.82,35,127.6,47.41,130.42,60h6.44q177.5,0,355-.14C501.12,59.87,508,62.36,512,71ZM177,269.86H425.73q25.63-89.7,51.33-179.61h-340C150.4,150.18,163.67,209.89,177,269.86Zm18.09,120.22A15,15,0,1,0,210,405.13,15.09,15.09,0,0,0,195.09,390.08ZM406.85,420A15,15,0,1,0,392,404.89,15.09,15.09,0,0,0,406.85,420Z"/><path d="M357.81,185.61c0,2.51-1.35,3.86-3.86,3.86H313.21v40.74c0,2.51-1.35,3.86-3.86,3.86H291.2c-2.51,0-3.86-1.35-3.86-3.86V189.47H246.6c-2.51,0-3.86-1.35-3.86-3.86V167.46c0-2.51,1.35-3.86,3.86-3.86h40.74V122.86c0-2.51,1.35-3.86,3.86-3.86h18.15c2.51,0,3.86,1.35,3.86,3.86V163.6H354c2.51,0,3.86,1.35,3.86,3.86Z"/></g></g></svg></button></form>';
      }
    var itemQuickAddcart = '<div class="quick-add-cart">'+
    quick_button
    +
    '</div>';

    if (data.tags.includes("pre-order")) {
      itemQuickAddcart = '<div class="pre-order-badge-custom">Pre Order at 40% OFF</div>'
    }
// console.log(data.available)
    // Add main attribute (Always put at the end of this function)
    var itemWishlistHtml = "<!-- include 'wishlist-button-collection' with '" + data.id + "' -->";
    itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    if(data.available){
    itemHtml = itemHtml.replace(/{{itemQuickAddcart}}/g, itemQuickAddcart);
    }
    else{
      itemHtml = itemHtml.replace(/{{itemQuickAddcart}}/g, "");
    }
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));

    return itemHtml;
  };

  // Build Swatch
  function buildSwatch(data, _this) {
    var itemSwatchHtml = '';
    var itemSwatchHoverImagesHtml = '';
    if (boostPFSConfig.custom.collection_color_swatches) {
      var swatchItems = [];
      var swatchHoverImages = [];
      data.options_with_values.forEach(function(option, index) {
        var option_name = option.name.toLowerCase();
        if (option_name.indexOf('color') != -1 || option_name.indexOf('colour') != -1) {
          var option_index = index;
          var values = [];
          data.variants.forEach(function(variant) {
            var value = variant.merged_options[option_index].split(':')[1];
            if (values.indexOf(value) == -1) {
              values.push(value);
              var colorValueSlugify = Utils.slugify(value);
              var colorImage = Utils.optimizeImage(boostPFSAppConfig.general.file_url.replace('/?', '/' + colorValueSlugify + '.png?'), '50x');
              var variantImage = Utils.optimizeImage(variant.image, '400x');

              var swatchItem = '<a href="{{itemUrl}}?variant={{variantId}}" ' +
                'class="color-swatch color-swatch--small color-swatch--{{colorValueSlugify}} {{swatchClass}}" ' +
                'data-variant-id="{{variantId}}" ' +
                'data-variant-image="{{variantImage}}" ' +
                'style="background-image: url({{colorImage}}); background-color: {{backgroundColor}};"> ' +
                '</a>';
              
              swatchItem = swatchItem.replace(/{{variantId}}/g, variant.id);
              swatchItem = swatchItem.replace(/{{colorValueSlugify}}/g, colorValueSlugify);
              swatchItem = swatchItem.replace(/{{swatchClass}}/g, variant.image ? 'color-swatch--with-image' : '');
              swatchItem = swatchItem.replace(/{{variantImage}}/g, variantImage);
              swatchItem = swatchItem.replace(/{{colorImage}}/g, colorImage);
              swatchItem = swatchItem.replace(/{{backgroundColor}}/g, colorValueSlugify.split('-').pop());

              var swatchHoverImage = '<div class="grid-product__color-image grid-product__color-image--' + variant.id + ' small--hide"></div>';

              swatchItems.push(swatchItem);
              swatchHoverImages.push(swatchHoverImage);
            }
          });
        }
      });
      if (swatchItems.length > 1) {
        itemSwatchHtml = ' <div class="grid-product__colors grid-product__colors--{{itemId}}" >' + swatchItems.join('') + '</div>';
        itemSwatchHoverImagesHtml = swatchHoverImages.join('');
      }
    }
    return {
      itemSwatch: itemSwatchHtml,
      itemSwatchHoverImages: itemSwatchHoverImagesHtml
    };
  }

  /************************** END BUILD PRODUCT LIST **************************/

  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    var paginationHtml = '';
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage > 1) {

      var paginationHtml = boostPFSTemplate.paginateHtml;

      // Build Previous
      var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);


      // Build Next
      var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Create page items array
      var beforeCurrentPageArr = [];
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...');
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = '';
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }
      
    return '';
  };

  /************************** BUILD TOOLBAR **************************/

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function() {
    var html = '';
    var sortingArr = Utils.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        if(sortingArr[k]=="Refine By")
        {
          sortingItemsHtml += '<option value="' + k + '">Filter By</option>';
        }
        else
        { 
          sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
        }
      }
      html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
    }
    return html;
  };

  /* buildExtraProductList */
  ProductList.prototype.afterRender = function(data) {
    if (!data) data = this.data;

    // Hover color swatch
    onColorSwatchHover();

    window.pslick.slick('unslick');
    jQuery('.slick-slider-x').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: false,
      nextArrow: false,
      dots:true
    });
  };

  function onColorSwatchHover() {
    document.querySelectorAll('.color-swatch--with-image').forEach(swatch => {
      swatch.addEventListener('mouseenter', function() {
        var id = swatch.dataset.variantId;
        var image = swatch.dataset.variantImage;
        var el = document.querySelector('.grid-product__color-image--' + id);
        el.style.backgroundImage = 'url(' + image + ')';
        el.classList.add('is-active');
      });
      swatch.addEventListener('mouseleave', function() {
        var id = swatch.dataset.variantId;
        document.querySelector('.grid-product__color-image--' + id).classList.remove('is-active');
      });
    });
  }

  /* buildAdditionalElements */
  Filter.prototype.afterRender = function(data, eventType) {
    if (!data) data = this.data;

    // Call theme init function
    //wrap all javascript use theme in window.ready event to make sure theme init and register sections successfully
    jQ(document).ready(function() {
      if (typeof theme !== null && window.theme) {
        if(typeof AOS != 'undefined' && typeof AOS.refreshHard == 'function'){
          AOS.refreshHard();
        }
        // Setup page transition classes
        if (typeof theme.pageTransitions == 'function') {
          theme.pageTransitions();
        }

        // Quickview button: Use boost otp & otp style 3, disable add to cart

        // // Reload products inside each quick shop
        // if (typeof sections !== null && sections) sections.register('product-template', theme.Product);
        if (window.$ && typeof $ == 'function') {
          $(window).off('popstate');
        }
      }

      if (isFirstLoad) {
        isFirstLoad = false;
      }

      // jQ('.js-drawer-open-collection-filters').on('click', function() {
      //   jQ('.' + Class.filterOption).each(function() {
      //     var showMoreType = jQ(this).data('show-more-type');
      //     if (showMoreType && jQ(this).data('display-type') != 'range') {
      //       self.buildFilterShowMore(jQ(this).find('.' + Class.filterBlockContent), showMoreType);
      //     }
      //   });
      // });
    });
    // Add modal container for quickview
    var isReinitQuickview = !isFirstLoad || Utils.isSearchPage() || Globals.queryParams.hasOwnProperty('_');
    if (!Utils.isMobile() && boostPFSConfig.custom.quick_shop_enable && isReinitQuickview) {
      jQ('.boost-pfs-quick-shop-modal-container').html('');
      if (data.products.length > 0) {
        data.products.forEach(function(product){
          var quickUrl = Utils.buildProductItemUrl(product) + '?view=boost-pfs-quickview';
          jQ.ajax({url: quickUrl, success: function(result) {
            numberQuickViewModalLoaded++;
            jQ('.boost-pfs-quick-shop-modal-container').append(result);
            if (numberQuickViewModalLoaded == data.products.length) {
              theme.collapsibles.init();
              numberQuickViewModalLoaded = 0;
              jQ('.quick-product__btn').removeClass('bc-hide');
            }
          }});
        });
      }
    }

    // Build total products text
    var totalProductText = '';
    if (data.total_product == 1) {
      totalProductText = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
    } else {
      totalProductText = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
    }
    jQ('.boost-pfs-filter-total-product').html(totalProductText);

    // Build filter button text on mobile
    // var numSelectedFilter = jQ('.boost-pfs-filter-tree .boost-pfs-filter-selected-items .boost-pfs-filter-option-label').length;
    // if (numSelectedFilter) {
    //   jQ('.js-drawer-open-collection-filters').addClass('btn--tertiary-active');
    //   jQ('.js-drawer-open-collection-filters > span').html(boostPFSConfig.label.filter + ' (' + numSelectedFilter + ')');
    // } else {
    //   jQ('.js-drawer-open-collection-filters').removeClass('btn--tertiary-active');
    //   jQ('.js-drawer-open-collection-filters > span').html(boostPFSConfig.label.filter);
    // }
    theme.initQuickShop();

    if (jQ('.boost-pfs-filter-options-wrapper .boost-pfs-filter-option').length == 0) {
      jQ('body').addClass('boost-no-filter');
    }
  };
})();